import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { TestimonialSection } from '../components/TestimonialSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <main className="w-full min-h-screen bg-cream" data-id="element-158">
      <Hero data-id="element-159" />
      <ProblemSection data-id="element-160" />
      <SolutionSection data-id="element-161" />
      <BenefitsSection data-id="element-162" />
      <TestimonialSection data-id="element-163" />
      <FinalCTASection data-id="element-164" />
      <Footer data-id="element-165" />
    </main>;
}